import { MouseEvent, useCallback } from 'react';
import useTailorTracking from 'app/modules/tailor/hooks/useTailorTracking';

import useLiveChatTracking from '../modules/live-chat/hooks/useLiveChatTracking';

export enum LinkType {
  TOU = 'ToU',
  PP = 'PP',
  NN_TOOLTIP = 'NNtooltip',
  URL = 'url',
}

export default function useLinkClickCapture() {
  const { captureLinkClicked } = useLiveChatTracking();
  const { captureTOULinkClick, capturePPCLick } = useTailorTracking();

  return useCallback(
    /**
     * Tries to capture the link click event based on multiple conditions
     * @returns whether the event was captured
     */
    (event: MouseEvent): boolean => {
      // @ts-ignore
      const link = event.target.closest('a');
      if (!link) return false;

      let linkType: LinkType = LinkType.URL;

      const termsRegEx = /ostrohealth.com(.+)terms-of-use/gim;
      const privacyRegEx = /ostrohealth.com(.+)privacy-policy/gim;

      if (termsRegEx.test(link.href)) {
        linkType = LinkType.TOU;
        queueMicrotask(() => captureTOULinkClick());
        return true;
      }

      if (privacyRegEx.test(link.href)) {
        linkType = LinkType.PP;
        queueMicrotask(() => capturePPCLick());
        return true;
      }

      if (link.dataset.content && link.dataset.anchor && link.getAttribute('href') === '#') {
        linkType = LinkType.NN_TOOLTIP;
        queueMicrotask(() => {
          captureLinkClicked(linkType, link.href);
        });
        return true;
      }

      return false;
    },
    [captureLinkClicked, captureTOULinkClick, capturePPCLick]
  );
}
